// Angular
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

// Modules
import { AccessRoutesModule } from './access.routing';
import { LayoutsModule } from '../shared/layouts/layouts.module';
import { LibModule } from '../shared/lib/lib.module';
import { SharedModule } from '../shared/shared.module';

// Components
import { AccessComponent } from './access.component';
import { LoginComponent } from './login/login.component';
import { RememberPassComponent } from './rememberPass/rememberPass.component';
import { ResetPassComponent } from './resetPass/resetPass.component';
import { SignupNewComponent } from './signup-new/signup-new.component';

// Others
import { CommonModule } from '@angular/common';
import { LanguagesLinksComponent } from './languages-links/languages-links.component';

// Store
import { NgHcaptchaModule } from 'ng-hcaptcha';

@NgModule({
    declarations: [
        AccessComponent,
        LoginComponent,
        SignupNewComponent,
        RememberPassComponent,
        ResetPassComponent,
        LanguagesLinksComponent
    ],
    imports: [
        AccessRoutesModule,
        NgHcaptchaModule.forRoot({
            // siteKey: 'ee4bfc18-4b3f-4fdf-b030-7a5293bb9b74'
            siteKey: 'feb7d493-0efe-4b32-a44f-301d6f66a3ac'
        }),
        LibModule,
        CommonModule,
        HttpClientModule,
        LayoutsModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule
    ],
    providers: [],
    bootstrap: [AccessComponent]
})
export class AccessModule {}
